// Model.js
// -----------------------
// @module Case
define("Ames.CheckoutUrl.CheckoutUrl.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/CheckoutUrl/SuiteScript2/CheckoutUrl.Service.ss"
            ),
            true
        )
});
});
